
export enum DeliveryMethod {
  Normal = 'Normal',
  ExpressToPostOffice = 'ExpressToPostOffice',
  ExpressHomeDelivery = 'ExpressHomeDelivery',
  ExpressCompanyDelivery = 'ExpressCompanyDelivery',
  DeliveredInProcessingCenter = 'DeliveredInProcessingCenter',
}
